// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"workHistory_actionsWrapper__jhN9I","actionLabel":"workHistory_actionLabel__qSKRV","action":"workHistory_action__UhtVv","worksList":"workHistory_worksList__vbMGo"};